// const serverApi = "http://next.weliveon.net:1337";
const serverApi = process.env.VUE_APP_REST_SERVER;

export const Constant = Object.freeze({
    ClassroomGetApi: serverApi + "/api/v1/classroom",
    ClassroomUserPostApi: serverApi + "/api/v1/classroomuser",
    FullGetApi: serverApi + "/api/v1/paper",  // qna paper list
    PaperApi: serverApi + "/api/v1/paper",  // qna paper list
    QnaListGetApi: serverApi + "/api/v1/qna",  // qna list and view 
    QnaCommentApi: serverApi + "/api/v1/qnacomment",
    QnaLikeApi: serverApi + "/api/v1/qnalike",
    QnaLikeCustomApi: serverApi + "/api/v1/qna/like_check",


    SlideGetApi: serverApi + "/api/v1/paper/join",
    NonItemlist: serverApi + "/api/v1/custom/item_all", // non quiz full list 

    NonItemPost: serverApi + "/api/v1/item_apply_log", // non quiz full list 
    NonItemApply: serverApi + "/api/v1/item_apply", // 
    ShortenApi: serverApi + "/api/v1/shorten",
    UniqueNickApi: serverApi + "/api/v1/shorten",
    ServicePrivacy: serverApi + "/api/v1/service_policy_board",




})